"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NumberInput = void 0;
var _react = _interopRequireWildcard(require("react"));
var _utils = require("ethers/lib/utils");
var _Input = require("./Input");
var _excluded = ["decimals", "value", "isBigNumber", "onChange"];
/**
 * @TODO: handle type="number" for auto numpad on mobile/screen readers
 */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Number input, with optional BigNumber parsing.
 */
var NumberInput = exports.NumberInput = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  var _ref$decimals = _ref.decimals,
    decimals = _ref$decimals === void 0 ? 18 : _ref$decimals,
    value = _ref.value,
    isBigNumber = _ref.isBigNumber,
    onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    inputValue = _useState2[0],
    setInputValue = _useState2[1];

  /**
   * Handle direct changes to the value prop which
   * weren't the result of typing.
   */
  (0, _react.useEffect)(() => {
    if (props.isDisabled) {
      return;
    }
    if (!value) {
      setInputValue('');
    } else {
      try {
        if (isBigNumber) {
          var formatted = (0, _utils.formatUnits)(value, decimals);
          setInputValue(formatted);
        } else {
          if (isNaN(Number(value))) {
            throw Error('Not a number.');
          }
          setInputValue(value);
        }
      } catch (_e) {
        setInputValue('');
        onChange('');
      }
    }
  }, [value]);

  /**
   * Handles input changes and validates the value.
   * @param value new input value
   */
  var onInputChange = value => {
    if (props.isDisabled) {
      return;
    }
    if (value === '') {
      onChange('');
      setInputValue('');
    } else {
      try {
        if (isBigNumber) {
          var newValue = (0, _utils.parseUnits)(value, decimals);
          onChange(newValue.toString());
        } else {
          if (isNaN(Number(value))) {
            return;
          }
          onChange(value);
        }
        setInputValue(value);
      } catch (_e) {
        // just catching to prevent state setting
        // if parseUnits throws
      }
    }
  };
  return /*#__PURE__*/_react.default.createElement(_Input.Input, _extends({
    type: "number",
    ref: ref,
    value: inputValue,
    onChange: onInputChange
  }, props));
});
//# sourceMappingURL=NumberInput.js.map